import notice from './notice'
export default notice